(() => {
  angular
    .module('gm.common.services')
    .factory('GmyVerification', GmyVerification);

  function GmyVerification(
    $q,
    Upload,
    gmApi,
    GmyToken,
    btgUser
  ) {
    'ngInject';

    const PROFILE_TYPES = {
      PROFILE: 'Profile',
      BUSINESS_PROFILE: 'BusinessProfile'
    };

    const ID_TYPES = {
      PASSPORT: 'Passport',
      LICENSE: 'Licence',
      NATIONAL: 'National',
      Form147C: 'Form147C',
      FormSS4: 'FormSS4'
    };

    return {
      PROFILE_TYPES,
      ID_TYPES,

      addPersonalNumber,
      confirmDocumentUpload,
      generateUploadIdCode,
      resendPhoneNumberVerification,
      uploadDocument,
      uploadId,
      validateProfileByAugurHID,
      verifyEmail,
      verifyPhoneNumber,
    };

    function addPersonalNumber(personalNumber) {
      return gmApi.post('uploads/addPersonalNumber', { personalNumber }, { auth: true });
    }

    function confirmDocumentUpload(code, type = PROFILE_TYPES.PROFILE) {
      return gmApi
        .post(`users/validations/mail/${code}/confirm`, {}, {
          auth: true,
          params: { validationType: type }
        })
        .then(() => {
          if (type === PROFILE_TYPES.PROFILE) {
            btgUser.updateProfileLocally({ documentSent: true });
          }
        });
    }

    function generateUploadIdCode(data) {
      const formData = {
        metadata: {
          type: 'IdWithData',
          value: data
        }
      };

      return gmApi
        .post('uploads/create', formData, { auth: true })
        .then(response => response.id);
    }

    function resendPhoneNumberVerification() {
      return gmApi.post('users/verifications/signUpPhone', {}, { auth: true });
    }

    function uploadDocument(file, data) {
      const metadata = Upload.json({
        metadata: {
          type: 'IdWithData',
          value: data,
        },
      });
      return Upload.upload({
        url: `${gmApi.getApiBasePath()}uploads/upload`,
        data: {
          metadata,
          file,
        },
        headers: { 'X-Auth-Token': GmyToken.getToken() },
      });
    }

    function uploadId(file, code) {
      const defer = $q.defer();

      Upload
        .upload({
          url: `${gmApi.getApiBasePath()}uploads/upload/${code}`,
          file,
          headers: { 'X-Auth-Token': GmyToken.getToken() }
        })
        .then(() => defer.resolve(), error =>
          defer.reject(error), evt =>
            defer.notify(evt));

      return defer.promise;
    }

    function validateProfileByAugurHID(hid, type) {
      const params = {
        validationType: type
      };

      return gmApi
        .post('users/validations/profile', { hid }, { auth: true, params })
        .then(() => {
          if (type === PROFILE_TYPES.BUSINESS_PROFILE) {
            btgUser.updateProfileLocally({ businessProfileValidated: true });
          }

          if (type === PROFILE_TYPES.PROFILE) {
            btgUser.updateProfileLocally({ profileValidated: true });
          }
        });
    }

    function verifyEmail(token) {
      return gmApi.put(`users/verifications/signUpEmail/${token}`, {}, { token: true });
    }

    function verifyPhoneNumber(token) {
      return gmApi.put(`users/verifications/signUpPhone/${token}`, {}, { auth: true });
    }
  }
})();
